import { combineReducers } from "redux";

import appReducer from "./AppReducer";
import settingsReducer from "./SettingsReducer";
import syncReducer from "./SyncReducer";
import TasksReducer from "./TasksReducer";

export default combineReducers({
    app: appReducer,
    settings: settingsReducer,
    sync: syncReducer,
    tasks: TasksReducer
});
